import React from 'react';

import { Button } from 'antd';
import Logo from 'assets/images/LogoIconAndTextHorizontal.svg';
import { logout } from 'presentation/redux/features/authen/authenSlice';
import { AUTH_ROUTES } from 'presentation/router/CONSTANTS';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const CU00100Page = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(logout());
    }, []);

    const gotoLoginPage = () => {
        navigate(AUTH_ROUTES.PATH + '/' + AUTH_ROUTES.SUB.CU_001_04);
    };

    const gotoRegisterPage = () => {
        navigate(AUTH_ROUTES.PATH + '/' + AUTH_ROUTES.SUB.CU_001_01);
    };

    return (
        <div
            className="width-full-screen center-inside CU-001-04-container"
            style={{
                height: '100vh',
            }}
        >
            <div style={{ width: 343 }}>
                <div
                    className="center-inside center"
                >
                    <img alt="logo" src={Logo} className='logo'/>
                </div>
                <div
                    className="title"
                    style={{ width: '100%', textAlign: 'center', marginTop: 24, marginBottom: 24 }}
                >
                    アカウント
                </div>
                <Button
                    className="button-login-text"
                    type="primary"
                    style={{
                        width: '100%',
                        height: 56,
                        marginTop: 16,
                        backgroundColor: 'var(--thirdly)',
                    }}
                    onClick={gotoRegisterPage}
                >
                    アカウント作成
                </Button>
                <Button
                    className="button-login-text"
                    type="primary"
                    style={{ width: '100%', height: 56, marginTop: 16 }}
                    onClick={gotoLoginPage}
                >
                    ログイン
                </Button>
            </div>
        </div>
    );
};
export default CU00100Page;
